var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card-group",
    { attrs: { deck: "" } },
    [
      _c(
        "b-link",
        {
          on: {
            click: function ($event) {
              return _vm.clickHandler("PP_One_Site")
            },
          },
        },
        [
          _c(
            "b-card",
            {
              staticClass: "text-center card",
              attrs: {
                "bg-variant": "info  ",
                "text-variant": "white",
                header: "PayPoint One",
              },
            },
            [
              _c("b-card-text", [
                _vm._v("I want to access my PayPoint One Account"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-link",
        {
          on: {
            click: function ($event) {
              return _vm.clickHandler("PP_Mini_Site")
            },
          },
        },
        [
          _c(
            "b-card",
            {
              staticClass: "text-center card",
              attrs: {
                "bg-variant": "info",
                "text-variant": "white",
                header: "PayPoint Mini",
              },
            },
            [
              _c("b-card-text", [
                _vm._v("I want to access my PayPoint Mini Account"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }